import type { BasicStoreFragment } from '@drycut/graphql';

import { StoreWaitingTime } from '@drycut/controlled-components';
import { Button, Heading, Para, Stack } from '@drycut/ui-components';
import { capitalize } from '@drycut/ui-format-utils';
import { Link } from 'react-router';

type Props = {
  includeWaitingTime?: boolean;
  salon: BasicStoreFragment;
};

export default function SalonCard({ salon, includeWaitingTime }: Props): React.ReactElement {
  const to = `/${salon.slug}`;

  return (
    <Stack className="group transition-all bg-zinc-950 text-zinc-100 shadow hover:shadow-md">
      <Stack>
        <Stack gap={10} className="p-16">
          <Stack>
            <Heading variant="h3" className="text-2xl text-left leading-none">
              {salon.location?.city.toUpperCase()} - {salon.name}
            </Heading>

            <Heading variant="h5" className="text-zinc-100 text-left text-sm">
              {salon?.location?.street}, {salon?.location?.zipCode} {salon?.location?.city}
            </Heading>
          </Stack>

          <Stack direction="row" gap={10} className="justify-between">
            <Stack gap={2}>
              <Para size="lg">Wartezeit / nächster Termin</Para>
              <Heading variant="h2" className="text-left text-primary-600 text-3xl">
                <StoreWaitingTime store={salon} showZero long hours />
              </Heading>
            </Stack>

            <Stack gap={2}>
              <Para size="lg">Preis</Para>
              <Heading variant="h2" className="text-left text-primary-600 text-3xl">
                42 CHF
              </Heading>
            </Stack>
          </Stack>
        </Stack>

        {includeWaitingTime && (
          <Stack direction="row" gap={1} className="justify-start">
            <Para as="span" size="sm" className="text-zinc-600">
              <StoreWaitingTime store={salon} showZero long hours />
            </Para>
          </Stack>
        )}

        <Button as={Link} to={to} className="font-normal font-aribau tracking-normal text-xl py-4">
          Cut Now @ {capitalize(salon.slug || '')}
        </Button>
      </Stack>
    </Stack>
  );
}
